/**
 * Attentive header trigger button.
 *
 * - Opens an Attentive sign-up unit via `window.__attentive.trigger(...)` when an element
 *   carrying `data-attentive-creative-id` is clicked (deduped via `window.__peAttentiveTriggerBound`
 *   so a creative never opens twice). The Attentive tag loads asynchronously, so the call is
 *   retried until `window.__attentive.trigger` is available.
 * - Dismisses the "unread" dot permanently after the first time the trigger is opened,
 *   persisted in localStorage. Reuses the shared `.klaviyo-trigger` button styling/class.
 */
(function () {
  // Open the Attentive sign-up unit. Guarded so it binds only once, and retried because the
  // Attentive tag (window.__attentive) loads asynchronously and may not be ready on early clicks.
  if (!window.__peAttentiveTriggerBound) {
    window.__peAttentiveTriggerBound = true;
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-attentive-creative-id]');
      if (!trigger) return;
      var creativeId = trigger.getAttribute('data-attentive-creative-id');
      if (!creativeId) return;
      event.preventDefault();

      var tries = 0;
      (function attempt() {
        if (window.__attentive && typeof window.__attentive.trigger === 'function') {
          window.__attentive.trigger(null, null, null, creativeId);
        } else if (tries++ < 20) {
          setTimeout(attempt, 250);
        }
      })();
    });
  }
})();
